import {
    apiRequest,
    bobotTunjanganKhususList,
    // bobotTunjanganKhususActive,
    // bobotTunjanganKhususInactive,
} from "../../../../../../services/adapters/master/bobotTunjanganKhususService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", bobotTunjanganKhususList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    // fetchInactive = async (query) => {
    //     return await apiRequest("post", bobotTunjanganKhususInactive, {
    //         body: query
    //     }, true)
    // }

    // fetchActive = async (query) => {
    //     return await apiRequest("post", bobotTunjanganKhususActive, {
    //         body: query
    //     }, true)
    // }
}

export default DataTableRepository